import React from 'react';
import PropTypes from 'prop-types';
import Configurator from '../components/Configurator';

const ConfiguratorPage = (props) => {
  
  return (
    <div className="container">
      <Configurator reset={props.params.reset} />
    </div>
  );
};

ConfiguratorPage.propTypes = {
  params: PropTypes.object.isRequired,
};

export default ConfiguratorPage;


// WEBPACK FOOTER //
// ./src/containers/ConfiguratorPage.js